<template>
  <div>
    <Header
      :homePage="true"
      style="margin-bottom:1.31rem;padding:0.5rem 0.37rem 0 0.4rem"
    />
    <!-- 审核中 -->
    <div class="stateBigBox" v-if="state == 4 || state == 2 || state == 20">
      <img src="./assets/images/pending.png" alt="" />
      <h5>Gracias por elegir CrediSol</h5>
      <p style="padding:0 0.75rem">
        Hemos recibido su solicitud de préstamo. Estamos verificando las
        informaciones de su crédito historial. Por favor esperese con paciancia,
        te pondremos en contacto tras la App y SMS en unos minutos.
      </p>
    </div>
    <!-- 放款失败 -->
    <div class="stateBigBox" v-else-if="state == 6">
      <img src="./assets/images/error.png" alt="" />
      <p style="width:5.95rem;margin-bottom:1.35rem">
        Lo sentimos, hay error en la transferencia de banco, la operación está
        fallada. Por favor, consulta con servicio al cliente relevante.
      </p>
      <div class="concat" style="margin-bottom: 0.5rem">
        <img src="./assets/images/photoIcon.png" alt="" />
        <div>
          <h3>Número telefónico:</h3>
          <p @click="openApply('+5117309229', 1)">+51 17309229</p>
        </div>
      </div>
      <div class="concat">
        <img src="./assets/images/whatsapp.png" alt="" />
        <div>
          <h3>WhatsApp:</h3>
          <p @click="openApply('+51926859015', 2)">+51 926859015</p>
        </div>
      </div>
    </div>
    <!-- 拒贷 -->
    <div class="stateBigBox" v-else-if="state == 3">
      <img src="./assets/images/refuse.png" alt="" />
      <h5>
        Puede volver a solicitar en
        <span>{{ $setMoment(userInfo.reapply_time, 1, 1) }}</span>
      </h5>
      <p style="width:5.6rem">
        Lo sentimos, su solicitud no ha aprobado, actualmente su valor de
        crédito es insuficinete, por favor mantenga un buen historial
        crediticio.
      </p>
    </div>
    <!-- 放款中 -->
    <div class="stateBigBox" v-else-if="state == 12 || state == 5">
      <img src="./assets/images/moneypending.png" alt="" />
      <p style="margin-bottom: 0.3rem;width: 6.1rem">
        Hay retraso bancario en el proceso del envío de dinero, le avisaremos
        por SMS cuando la transferencia sea exitosa.
      </p>
      <p style="width: 5.1rem">
        El depósito sería atrasado durante los días no laborales.
      </p>
    </div>
  </div>
</template>

<script>
import Header from "./components/header.vue";
import { getInfor } from "../utils/api/h5page.js";
export default {
  name: "",
  components: {
    Header,
  },
  props: {},
  data() {
    return {
      state: "",
      userInfo: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getUserInformation();
  },
  mounted() {},
  methods: {
    // 获取用户订单信息
    getUserInformation() {
      getInfor().then(({ data }) => {
        console.log(data);
        this.userInfo = data.data.loan_info;
        this.state = data.data.loan_info.order_status;
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      });
    },

    openApply(mobile, row) {
      if (row == 1) {
        window.location.href = "tel:" + mobile;
      } else {
        this.$Toast("Se está abriendo WhatsApp...");
        window.open("https://api.whatsapp.com/send?phone=" + mobile);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stateBigBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  & > img {
    width: 100%;
    margin-bottom: 0.7rem;
  }
  h5 {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.28rem;
    color: #3a3a3a;
    margin-bottom: 0.3rem;
    span {
      color: #224c9e;
    }
  }
  p {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.28rem;
    color: #333333;
    text-align: center;
  }
  .concat {
    display: flex;
    img {
      width: 0.6rem;
      height: 0.6rem;
      margin-right: 0.2rem;
    }
    h3 {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.22rem;
      color: #999999;
    }
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.26rem;
      color: #c90000;
      text-decoration-line: underline;
    }
  }
}
</style>
